/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ProfilesIndexPathParams, ProfilesIndexResponse } from '../types/ProfilesIndex'

/**
 * GET /:organisation/profiles
 * @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::index
 */
export async function profilesIndex(
	organisation: ProfilesIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ProfilesIndexResponse>> {
	return axiosInstance.get(`/${organisation}/profiles`, config)
}
